// @ts-nocheck
import { useState } from "react"
import { Input } from "@/components/ui/input"
import { X } from "lucide-react"

interface EmailInputProps {
  onChange?: (emails: string[]) => void
  emailList?: string[]
}

export default function EmailInput({ onChange, emailList }: EmailInputProps) {
  const [emails, setEmails] = useState<string[]>(emailList || [])
  const [input, setInput] = useState("")

  const updateEmails = (newEmails: string[]) => {
    setEmails(newEmails)
    onChange?.(newEmails)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.key === "Enter" || e.key === ",") && input.trim()) {
      e.preventDefault()
      const trimmed = input.trim().replace(/,$/, "")
      if (validateEmail(trimmed) && !emails.includes(trimmed)) {
        updateEmails([...emails, trimmed])
        setInput("")
      }
    } else if (e.key === "Backspace" && !input && emails.length > 0) {
      updateEmails(emails.slice(0, -1))
    }
  }

  const handleRemove = (email: string) => {
    updateEmails(emails.filter(e => e !== email))
  }

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-2 mb-2">
        {emails.map(email => (
          <span key={email} className="flex items-center bg-muted px-2 py-1 rounded-full text-sm">
            {email}
            <button
              type="button"
              onClick={() => handleRemove(email)}
              className="ml-1 text-muted-foreground hover:text-foreground"
            >
              <X className="w-3 h-3" />
            </button>
          </span>
        ))}
      </div>
      <Input
        placeholder="Enter email and press Enter"
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  )
}

function validateEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}